import { render } from "./Approfondimenti.vue?vue&type=template&id=31a57722&scoped=true"
import script from "./Approfondimenti.vue?vue&type=script&lang=js"
export * from "./Approfondimenti.vue?vue&type=script&lang=js"

import "./Approfondimenti.vue?vue&type=style&index=0&id=31a57722&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\mdv-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a57722"]])

export default __exports__